import { createSvgIcon } from "@mui/material";

export const AlignTBIcon = createSvgIcon(
  <svg viewBox="0 0 9 15" fill="none">
    <path
      fill="currentColor"
      d="M8.438 13.898a.625.625 0 0 1-.633.633H.633A.64.64 0 0 1 0 13.898c0-.369.29-.632.633-.632h7.172a.61.61 0 0 1 .633.632"
    />
    <path fill="currentColor" d="M3.586 13.266v-12h1.266v12z" />
    <path
      fill="currentColor"
      d="M8.438.633a.625.625 0 0 1-.633.633H.633A.64.64 0 0 1 0 .633C0 .263.29 0 .633 0h7.172a.61.61 0 0 1 .633.633"
    />
  </svg>,
  "AlignTBIcon",
);
